import dayjs from "dayjs";
import tz from "dayjs/plugin/timezone";

dayjs.extend(tz);
const timeZone = dayjs.tz.guess();

export const combineDateTimeAndConvertToUTC = (date, time) => {
  const dateObj = new Date(date);
  const timeObj = new Date(time);

  // Set hours and minutes from startTime to startDate
  dateObj.setHours(timeObj.getHours());
  dateObj.setMinutes(timeObj.getMinutes());

  // Convert combined date to UTC string
  const dateTimeUTC = dateObj.toISOString();

  return dateTimeUTC;
};

export const separateDateTimeAndConvertToLocale = (utcDate) => {
  if (!utcDate) return null;

  const parsedDate = typeof utcDate === "string" ? new Date(utcDate) : utcDate;

  if (isNaN(parsedDate)) return null;

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const localTime = parsedDate.toLocaleTimeString("en-US", {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
  });
  const localDate = new Date(utcDate).toLocaleDateString("en-US", {
    timeZone: timeZone,
  });
  return { localDate, localTime };
};

export const roleEnum = {
  merchant: "merchant/",
  fundraiser: "fundraiser/"
};

const userRoutes = [
  "/business-profile",
  "/more-information",
  "/submit-information",
  "/subscription",
  "/fundraiser-subscription",
  // "/membership-activation", // removed
  "/member-setup",
  "/membership-confirmation",
  "/membership-activated",
  "/fundraiser-brand",
  "/success",
  "/existing-login",
  "/user-forgetPassword",
  "/user-otpVerification",
  "/user-resetPassword",
  "/existing-subscription",
  "/subscription-failed",
];

export const isUserRoute = userRoutes.some((route) =>
  window.location.pathname.startsWith(route)
);

export const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Scrolls the view to the first form field with an error.
 * @param {Object} formErrors - Object containing formik errors.
 * @param {Array} priority - Optional list of field names to check in order.
 */
export const scrollToFirstError = (formErrors, priority = []) => {
  if (!formErrors || Object.keys(formErrors).length === 0) return;

  let targetField = priority.find(
    (key) => Object.prototype.hasOwnProperty.call(formErrors, key)
  );

  if (!targetField) {
    const keys = Object.keys(formErrors);
    targetField = keys.length ? keys[0] : null;
  }

  if (!targetField) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  const doc = window.document;
  // Try finding by data-field, then by name
  let el =
    doc.querySelector(`[data-field="${targetField}"]`) ||
    doc.querySelector(`[name="${targetField}"]`) ||
    doc.querySelector(`input[name="${targetField}"]`) ||
    doc.querySelector(`textarea[name="${targetField}"]`) ||
    doc.querySelector(`select[name="${targetField}"]`);

  if (el && typeof el.scrollIntoView === "function") {
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    if (typeof el.focus === "function") {
      try {
        el.focus();
      } catch (_) { }
    }
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};